<script setup lang="ts">
import { defineProps, computed } from 'vue'
import PayoutHintPanelFormGroup from "@/components/forms/payout/hint/PayoutHintPanelFormGroup.vue";
import {
  CurrencyCode,
  frontofficeCurrencyFilter,
  getAccountNumberCurrency
} from "@/models/core/currency";

const props = defineProps({
  model: {
    type: Object,
    required: true
  }
})

const model = computed(() => props.model)

const twoAccountsSelected = computed(() => {
  return model.value.values.fromAccount && model.value.values.destinationAccount
})

const sourceCurrency = computed(() => {
  return getAccountNumberCurrency(model.value.values.fromAccount)
})

const destinationCurrency = computed(() => {
  return getAccountNumberCurrency(model.value.values.destinationAccount)
})

const differentCurrency = computed(() => {
  return twoAccountsSelected.value
    && sourceCurrency.value && destinationCurrency.value
    && (sourceCurrency.value !== destinationCurrency.value)
})
</script>

<template>
<div v-if="twoAccountsSelected && differentCurrency">
  <PayoutHintPanelFormGroup :warning="true">
    <i18n path="exchangeMessage">
      <template v-slot:src>{{frontofficeCurrencyFilter(sourceCurrency, true)}}</template>
      <template v-slot:dst>{{frontofficeCurrencyFilter(destinationCurrency, true)}}</template>
    </i18n>
<!--    {{$t('Валюты счетов отправителя и получателя отличаются. Перевод пройдет по текущему курсу обмена.')}}-->
  </PayoutHintPanelFormGroup>
</div>
</template>

<style scoped lang="less">

</style>


<i18n>
{
  "en": {
    "exchangeMessage": "The currencies of the sender's and recipient's accounts are different. The {src} to {dst} exchange will be made at the current rate."

  },
  "ru": {
    "exchangeMessage": "Валюты счетов отправителя и получателя разные. Обмен {src} на {dst} будет произведен по текущему курсу."
  }
}
</i18n>
